<template>
  <div class="help-topics-card info-card home-card-shadow">
    <div class="info-card-content">
      <div class="icon" @click="topicSelected"><img :src="`/icons/${helpTopic.icon}`" /></div>
      <dynamicTemplate :template="`<div class='title ' >${helpTopic.title}</div>`" @click.native="topicSelected"/>
      <div class="faqsInCard mt-2">
        <div class="question" @click="questionSelected(faq.id)" v-for="faq in helpTopicFaqs"  :key="faq.id"><font-awesome-icon :icon="['fal', 'chevron-right']"/> <dynamicTemplate :template="`<span class='link'> ${faq.question}</span>`"/></div>

      </div>
      <p class="showAll link" @click="topicSelected">
        show all
      </p>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import dynamicTemplate from 'v-runtime-template';


const { mapGetters } = createNamespacedHelpers('helpTopics');
export default {
    name: 'help-topics-card',
    props: {
        helpTopic: Object,
    },
    components: {
        dynamicTemplate,
    },
    computed: {
        ...mapGetters(['getHelpTopicFaqsByTagSorted']),
        helpTopicFaqs () {
            return this.getHelpTopicFaqsByTagSorted(this.helpTopic.tag).slice(0, 3);
        },
        clientConfig () {
            return this.$store.getters['clientConfig/clientConfig'];
        },
        fundOrScheme () {
            return this.clientConfig.fundOrScheme;
        },
    },
    methods: {
        topicSelected () {
            this.$emit('topicSelected');
        },
        questionSelected (questionId) {
            this.$emit('questionSelected', questionId);
        },
    },

};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';
.help-topics-card {
  width: 31%;
  flex: initial;
  @include responsive('md') {
    width: 49%;
  }
  @include responsive('sm') {
    width: 100%;
  }
}
.home-card-shadow {
    box-shadow: $boxShadow2;
  }

.info-card {
  background-color: white;
  // height: 9rem;
  margin-bottom: 1.5rem;
  border-radius: 0.5rem;
  .info-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    font-size: 1.2rem;
    padding: 2rem 2rem 1rem;
    ::v-deep .title {
      cursor: pointer;
    }
    .icon{
      cursor: pointer;
      img{
        height: 3rem;
      }
      margin-bottom: 1rem;
    }
    .faqsInCard{
      // text-align: center;;
      list-style: none;
      flex-grow: 1;
      .question{
        font-size: .8rem;
        margin-bottom: 0.5rem;;
        display: flex;;
        .link{
          text-decoration: none;;
          &:hover{
            text-decoration: underline;;
          }
        }
        svg{
          height: .6rem;
          margin-top: 0.4rem;
          margin-right: 0.2rem;
        }
      }
    }
    .showAll{
      font-size: .8rem;
      padding-left: 0.6rem;
      font-weight: bold;;
    }
  }
}
</style>
